import { Toast } from "bootstrap";

var toastContainer = document.createElement("div");
toastContainer.ariaLive = "polite";
toastContainer.classList.add("toast-container", "top-0", "start-50", "translate-middle-x");


export function initializeToastContainer(mapViewport: HTMLElement) {
    mapViewport.appendChild(toastContainer);
}

export function createToast(text:string, id?:string) {
    let toast = document.createElement("div");
    if (id) {
        toast.id = id;
    }
    toast.classList.add("toast");
    let toastBody = document.createElement("div");
    toastBody.classList.add("toast-body");
    let textSpan = document.createElement("span");
    textSpan.innerText = text;
    toastBody.appendChild(textSpan);
    let button = document.createElement("button");
    button.type = "button";
    button.classList.add("btn-close");
    button.setAttribute("data-bs-dismiss", "toast");
    toastBody.appendChild(button);
    toast.appendChild(toastBody);
    toastContainer.appendChild(toast);
    return new Toast(toast);
}